<!-- TODO: скрыл обратный звонок по задаче 23174 -->
<template>
    <div
        v-click-outside="() => isOpen = false"
        :class="['floating-chat-container', {active: isOpen}]"
    >
        <transition-group
            name="chat"
            tag="div"
        >
            <template
                v-for="({icon, key, link, isActive}, index) in floatingItems"
            >
                <a
                    v-if="isOpen && isActive"
                    :key="`item_${key}`"
                    :href="link || ''"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="floating-chat__item"
                    :style="{
                        transition: `
                            transform 0.3s ease ${index / 10}s, opacity 0.3s ease ${index / 10}s, background 0.3s ease
                        `
                    }"
                    @click="isOpen = false"
                    v-html="icon"
                />
            </template>
        </transition-group>
        <div
            class="floating-chat"
            @click="toggleChatsVisibility()"
        >
            <transition
                name="bouncee"
                mode="out-in"
            >
                <nuxt-img
                    v-if="isOpen"
                    src="components/floating-chat/close.svg"
                    alt=""
                    class="floating-chat__close"
                    format="webp"
                    loading="lazy"
                />
                <nuxt-img
                    v-else
                    src="icons/floating-chat/floating-chat.svg"
                    alt=""
                    format="webp"
                />
            </transition>
        </div>
    </div>
</template>

<script>
import {computed, defineComponent, ref} from 'vue';
import {useContext} from '@nuxtjs/composition-api';

import icons from '@/components/FloatingChat/icons';

export default defineComponent({
    name: 'FloatingChat',
    setup() {
        const {$isMobileOrTablet, $api} = useContext();

        const isOpen = ref(false);
        const isActiveEl = ref(false);

        const floatingItems = computed(() => {
            return [
                {
                    icon: icons.mail,
                    key: 'mail',
                    link: '/about/contacts',
                    isActive: true,
                },
                {
                    icon: icons.whatsapp,
                    key: 'whatsapp',
                    link: $isMobileOrTablet
                        ? 'https://wa.me/78002009929'
                        : 'https://web.whatsapp.com/send?phone=78002009929',
                    isActive: false,
                },
                {
                    icon: icons.vk,
                    key: 'vk',
                    link: 'https://vk.com/centrinvest',
                    isActive: isActiveEl.value,
                },
            ];
        });

        async function toggleChatsVisibility() {
            if (!isOpen.value) {
                try {
                    const {data} = await $api.common.chatStatus.get();
                    isActiveEl.value = data;
                } catch (error) {
                    isActiveEl.value = false;
                    console.error(error);
                }
            }
            isOpen.value = !isOpen.value;
        }

        return {
            isOpen,
            floatingItems,
            toggleChatsVisibility,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/floating-chat/floatingChat';
</style>
